import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ReactComponent as LockIcon } from "../../inlineSvgs/lock.svg";
import { ReactComponent as EmailIcon } from "../../inlineSvgs/email.svg";
import { ReactComponent as EyeIcon } from "../../inlineSvgs/eye.svg";
import { Link } from "react-router-dom";
import { signIn } from "../../api";
import { saveToken } from "../../store/slice/userSlice";
import GoogleLogIn from "../GoogleLogIn";
import FacebookLogIn from "../FacebookLogIn";
import { showNotification } from "../../config";

const LogInForm = () => {
  const [passIsHide, setPassIsHide] = useState(true);
  const [isPending, setPending] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      login: "",
      password: "",
    },
  });
  const redirect = useNavigate();
  const dispatch = useDispatch();

  const togglePassIsHide = () => {
    setPassIsHide(!passIsHide);
  };

  const onSubmit = async (data) => {
    setPending(true);
    try {
      const res = await signIn(data);

      if (res?.data?.access_token) {
        dispatch(saveToken(res.data.access_token));
        redirect("/");
      }
    } catch {
      setPending(false);
      showNotification("Wrong login or password")
    } finally {
      setPending(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <label htmlFor="login">Email Address or Phone Number</label>
      <div className="input-wrapper">
        <div className="icon-wrapper">
          <EmailIcon />
        </div>
        <input id="login" type="text" placeholder="Enter your email or phone number" {...register("login")} />
      </div>

      <label htmlFor="password">Password</label>
      <div className="input-wrapper">
        <div className="icon-wrapper">
          <LockIcon />
        </div>
        <input
          id="password"
          autoComplete="off"
          type={passIsHide ? "password" : "text"}
          placeholder="Enter your password"
          {...register("password")}
        />
        <button type="button" onClick={togglePassIsHide}>
          <EyeIcon />
        </button>
      </div>
      <div className="forgot">
        <button type="button" className="forgot-button">Forgot Passowrd?</button>
      </div>
      <div className="buttons-section">
        <div className="submit-section">
          <button type="submit" className="beauty-btn fill">
            {isPending ? <span>Loading...</span> : "Login"}
          </button>
          <Link to="/signup" className="beauty-btn border">
            Create New Account
          </Link>
        </div>
        <div className="delimiter">Or login using</div>
        <div className="login-by-social">
          <GoogleLogIn />
          <FacebookLogIn />
        </div>
      </div>
    </form>
  );
};

export default LogInForm;
